import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from "@angular/common";
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MenuDTO } from '../../../models/menu-dto';
import { Item } from 'src/app/models/menu-dto';

import { Helpers } from '../../../helpers/helpers';

@Component({
  selector: 'app-patterns',
  templateUrl: './patterns.component.html',
  styleUrls: ['./patterns.component.scss']
})

export class PatternsComponent implements OnInit {

  menu!: MenuDTO;
  items!: Item[];

  isInDevEnvironment = false;

  constructor(
    private scroller: ViewportScroller,
    private http: HttpClient,
    private router: Router,
    private helper: Helpers) {}

  ngOnInit() {
    console.log('init');
    this.showDevMenu();
    this.isInDevEnvironment = this.helper.isInDevEnvironment();
    if(!this.isInDevEnvironment) {
      this.router.navigate(["/home"]);
    }
  }

  scrollTo(anchor: string) {
    // console.log('scroll');
    this.scroller.setOffset([0,118]);
    this.scroller.scrollToAnchor(anchor);
    return false;
  }

  public getDevMenu(): Observable<MenuDTO> {
    console.log('get menu');
    return this.http.get<MenuDTO>('assets/develop/json/menu-dev.json');
  };

  public showDevMenu() {
    console.log('show menu');
    this.getDevMenu().subscribe(resp => {
      this.menu = resp;
      this.items = this.menu.Items;
      console.log(this.items);
    });
  }

}
